import { Box, Select, Text, TextFieldAppearance, TextFieldSize } from '@bechtel/gds';
import { Maybe, ToolRoom } from '@bechtel/ht-types';
import { FC } from 'react';

interface ToolRoomListProps {
  toolRooms: Maybe<ToolRoom>[];
  onToolRoomChange: (toolRoom?: ToolRoom | null) => void;
  textFieldSize?: TextFieldSize;
  placeholder?: string;
  disabled?: boolean;
  toolRoomId?: string;
  isDefaultRequired?: boolean;
}

const ToolRoomItem = ({ item }: { item: ToolRoom }) => {
  return (
    <Text color="grey.500" size="400">
      {item.description}
    </Text>
  );
};

export const ToolRoomDropDown: FC<ToolRoomListProps> = ({
  toolRooms = [],
  onToolRoomChange,
  textFieldSize = TextFieldSize.SMALL,
  placeholder = 'Please select',
  disabled = false,
  toolRoomId,
  isDefaultRequired = false,
}) => {
  const selectedToolRoom = toolRooms.find((toolRoom) => toolRoom && toolRoom.id === toolRoomId);
  return (
    <>
      {(!toolRooms || !toolRooms.length) && (
        <Box>
          <Text size="300" color="grey.700">
            No Tool Rooms assigned.
          </Text>
        </Box>
      )}
      {toolRooms.length > 0 && (
        <Box>
          <Select
            placeholder={placeholder}
            disabled={disabled}
            size={textFieldSize}
            name="toolRoomDropDown"
            appearance={TextFieldAppearance.TRANSPARENT}
            items={toolRooms}
            itemComponent={ToolRoomItem}
            selectedComponent={() =>
              selectedToolRoom ? selectedToolRoom?.description : isDefaultRequired ? toolRooms[0]?.description : null
            }
            initialSelectedItem={selectedToolRoom ? selectedToolRoom : isDefaultRequired ? toolRooms[0] : null}
            onSelectedItemChange={({ selectedItem }) => onToolRoomChange(selectedItem)}
          />
        </Box>
      )}
    </>
  );
};
